import logo from '../assets/img/LogoFullBM.webp';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
    const { t } = useTranslation();

    return <div>
        <div className="page-error-404">
            <div className="page-error-container">
                <img src={logo} width={"200px"}/>
                <div className="page-error-graphic">
                    <div className="page-error-number">4<span>0</span>4</div>
                    <h1>{t('notFoundPage.title')}</h1>
                    <p className="page-error-message">{t('notFoundPage.subtitle')}</p>
                    
                    <div className="page-action-buttons">
                        <a href="/" className="page-primary-button">
                            {t('notFoundPage.buttons.primary')}
                        </a>
                        <a href="/contact" className="page-secondary-button">
                            {t('notFoundPage.buttons.secondary')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}